package org.chiangmeng.qfast

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.initialize
import org.chiangmeng.qfast.core.data.FirebaseConfig
import org.chiangmeng.qfast.core.di.appModule
import org.koin.core.context.startKoin

private var isKoinInitialized = false

fun initKoin() {
    if (getPlatform().name.contains("Android", ignoreCase = true)) {
        return
    }
    if (!isKoinInitialized) {
        if (getPlatform().name.contains("iOS", ignoreCase = true) || getPlatform().name.contains("iPadOS", ignoreCase = true)) {
            println(">>> [STEP 1] Running on iOS: Firebase initialized via GoogleService-Info.plist")
        } else {
            println(">>> [STEP 1] Starting Firebase.initialize()...")
            try {
                Firebase.initialize(
                    options = FirebaseOptions(
                        apiKey = FirebaseConfig.API_KEY,
                        authDomain = FirebaseConfig.AUTH_DOMAIN,
                        databaseUrl = FirebaseConfig.DATABASE_URL,
                        projectId = FirebaseConfig.PROJECT_ID,
                        storageBucket = FirebaseConfig.STORAGE_BUCKET,
                        gcmSenderId = FirebaseConfig.GCM_SENDER_ID,
                        applicationId = FirebaseConfig.APPLICATION_ID
                    )
                )
                println(">>> [STEP 2] Firebase.initialize() SUCCESS!")
            } catch (e: Throwable) {
                println(">>> [STEP 2 FAILED] Firebase.initialize() CRASHED with: ${e.message}")
                e.printStackTrace()
            }
        }

        println(">>> [STEP 3] Starting Koin...")
        try {
            startKoin {
                modules(appModule)
            }
            println(">>> [STEP 4] Koin started successfully!")
            isKoinInitialized = true
        } catch (e: Throwable) {
            println(">>> [STEP 4 FAILED] Koin start failed: ${e.message}")
            isKoinInitialized = true
        }
    }
}
